import { render, staticRenderFns } from "./ChooseLabelSetModal.vue?vue&type=template&id=7264dfdd&scoped=true&"
import script from "./ChooseLabelSetModal.vue?vue&type=script&lang=js&"
export * from "./ChooseLabelSetModal.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/choose_label_set_modal.scss?vue&type=style&index=0&id=7264dfdd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264dfdd",
  null
  
)

export default component.exports